document.addEventListener("DOMContentLoaded", function () {
  //menu-mobile
  const hamb = document.querySelector("#hambur");
  const menMob = document.querySelector("#menuMobile");
  const menuItems = document.querySelector("#menuItems")
  
  if (hamb && menMob) {
      hamb.addEventListener("click", () => {
          menMob.classList.toggle("active");
          menuItems.classList.toggle("active");
          hamb.classList.toggle("prim");
      });
  }

  //scroll menu

function scrollDetect(){
  var lastScroll = 0;
  window.onscroll = function() {
      let currentScroll = document.documentElement.scrollTop || document.body.scrollTop; // Get Current Scroll Value
      const headerr = document.querySelector(".nav-principal");
      if (currentScroll  === 0){
        headerr.classList.remove("nav-active");
      }
       else if (currentScroll > 0 && lastScroll <= currentScroll){
        lastScroll = currentScroll;
        headerr.classList.add("nav-active");
      }else{
        lastScroll = currentScroll;
        headerr.classList.add("nav-active");
      }
  };
}
scrollDetect();
  
  //swiper-testimonios
  var swiper = new Swiper(".testi-swipe", {
    slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      nextEl: ".navt-next",
      prevEl: ".navt-prev",
    },
    loop: true,
    autoplay: {
      delay: 5500,
      disableOnInteraction: true,
    },
    breakpoints: {
      600: {
        slidesPerView: 2,
      },
      900: {
        slidesPerView: 3
      }
      
    },
  });

  //swiper-testimonios simple
  var swiper = new Swiper(".st-swiper", {
    slidesPerView: 1,
    navigation: {
      nextEl: ".st-next",
      prevEl: ".st-prev",
    },
    loop: true,
    autoplay: {
      delay: 4500,
      disableOnInteraction: true,
    },
  });

  //swiper-cta
  var swiper = new Swiper(".swiper-cta", {
    slidesPerView: 1,
    navigation: {
      nextEl: ".cta-next",
      prevEl: ".cta-prev",
    },
    loop: true,
    autoplay: {
      delay: 4500,
      disableOnInteraction: true,
    },
    effect: "fade",
  });

  //simple gallery
  var swiper = new Swiper(".swiper-sg", {
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      nextEl: ".sg-prev",
      prevEl: ".sg-next",
    },
    loop: true,
    autoplay: {
      delay: 4500,
      disableOnInteraction: true,
    },
    breakpoints: {
      600: {
        slidesPerView: 2,
      },
      900: {
        slidesPerView: 3
      }
      
    },
  });

  //swiper-corp
  var swiper = new Swiper(".corp-slide", {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: ".navb-next",
      prevEl: ".navb-prev",
    },
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },
    breakpoints: {
      600: {
        slidesPerView: 2,
      },
      900: {
        slidesPerView: 3
      }
      
    },
  });

  //faqs
  document.querySelectorAll('.faq-item').forEach((item) => {
    const question = item.querySelector('.question');
    const answer = item.querySelector('.answer');
    const icon = item.querySelector('.faq-icon');
    const circle = item.querySelector('.faq-circle');
  
    question.addEventListener('click', () => {
      const isVisible = answer.style.display === 'block';
  
      // Alternar visibilidad de la respuesta
      answer.style.display = isVisible ? 'none' : 'block';
  
      // Alternar rotación del ícono
      icon.style.transform = isVisible ? 'rotate(0deg)' : 'rotate(-45deg)';
      icon.style.transition = 'transform 0.3s ease';
  
      // Alternar color del círculo
      circle.setAttribute('fill', isVisible ? '#D6C9FE' : '#BB98F2');
    });
  });

  //detalles
  document.querySelectorAll('.q-item').forEach((item) => {
    const question = item.querySelector('.qut');
    const answer = item.querySelector('.qub');
    const icon = item.querySelector('.q-icon');
    const circle = item.querySelector('.faq-circle');
  
    question.addEventListener('click', () => {
      const isVisible = answer.classList.contains('active');
  
      // Alternar visibilidad de la respuesta
      answer.classList.toggle('active');
  
      // Alternar rotación del ícono
      icon.style.transform = isVisible ? 'rotate(0deg)' : 'rotate(-45deg)';
      icon.style.transition = 'transform 0.3s ease';
  
      // Alternar color del círculo
      circle.setAttribute('fill', isVisible ? '#D6C9FE' : '#BB98F2');
    });
  });

  //blog
  var swiper = new Swiper(".swiper-blog", {
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
        nextEl: ".next-blog",
        prevEl: ".prev-blog",
    },
    breakpoints: {
        600: {
            slidesPerView: 2,
        }
    },
    autoplay: {
      delay: 8500,
      disableOnInteraction: true,
    },
    loop: true,
      
  });

  //filtro


    const filters = document.querySelectorAll('.filter-list'); 
    const products = document.querySelectorAll('.product-item');

    filters.forEach(filter => {
      filter.addEventListener('click', () => {
        const filtro = filter.id.toLowerCase();

        filters.forEach(f => f.classList.remove('active'));

        filter.classList.add('active');

        products.forEach(product => {
          const tags = product.dataset.collection.toLowerCase();

          if (filtro === "todos-los-productos") {
            // Mostrar todos los productos
            product.classList.remove('hide');
            
          } else {
            // Filtrar productos que contienen el tag en data-collection
            if (tags.includes(filtro)) {
              product.classList.remove('hide');
              
            } else {
              product.classList.add('hide');
              
            }
          }
        });
      });
    });

  //cantidad producto
  document.querySelectorAll('.js-qty__wrapper').forEach(function (wrapper) {
      const input = wrapper.querySelector('.js-qty__num');
      const btnMinus = wrapper.querySelector('.js-qty__adjust--minus');
      const btnPlus = wrapper.querySelector('.js-qty__adjust--plus');

      const min = parseInt(input.getAttribute('min')) || 1;

      btnMinus.addEventListener('click', function () {
        let current = parseInt(input.value) || min;
        if (current > min) {
          input.value = current - 1;
        }
      });

      btnPlus.addEventListener('click', function () {
        let current = parseInt(input.value) || min;
        input.value = current + 1;
      });
    });

  //mover imagenes
  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;
  
    document.querySelectorAll('.parallax-img').forEach((img, index) => {
      const verticalOffset = scrollY * 0.15; // movimiento vertical
      const horizontalDirection = index % 2 === 0 ? -1 : 1; // alterna izq/der
      const horizontalOffset = scrollY * 0.03 * horizontalDirection; // movimiento sutil horizontal
  
      img.style.transform = `translate(${horizontalOffset}px, ${verticalOffset}px)`;
    });
  });

  //contadores
  let countersStarted = false;

  function animateCounters() {
    const counters = document.querySelectorAll('.counter');
    counters.forEach(counter => {
      const target = +counter.getAttribute('data-target');
      const duration = 2000; // duración en milisegundos
      const stepTime = 20;
      const increment = target / (duration / stepTime);
      let current = 0;
  
      const update = () => {
        current += increment;
        if (current < target) {
          counter.textContent = Math.floor(current);
          setTimeout(update, stepTime);
        } else {
          counter.textContent = target.toLocaleString(); // formato con comas si aplica
        }
      };
  
      update();
    });
  }
  
  function isInViewport(elem) {
    const rect = elem.getBoundingClientRect();
    return (
      rect.top < window.innerHeight && rect.bottom >= 0
    );
  }
  
  window.addEventListener('scroll', () => {
    const section = document.getElementById('stats');
    if (!countersStarted && isInViewport(section)) {
      countersStarted = true;
      animateCounters();
    }
  });




  
})



